/**
 * Labstep
 *
 * @module components/User/Modal/PermissionsFolder
 * @desc Action to add user to a group (join a group)
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { ProfilePicture } from 'labstep-web/components/Profile/Picture';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { Flex } from 'labstep-web/core/Flex';
import { Size } from 'labstep-web/core/Initials/types';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { User } from 'labstep-web/models/user.model';
import type React from 'react';
import type { UserModalPermissionsFolderProps } from './types';

export const UserModalPermissionsFolder: React.FC<
  UserModalPermissionsFolderProps
> = ({ folder }) =>
  folder.permissions_user_count > 0 ? (
    <ModalDefault
      header={`Users with access to collection ${folder.name}`}
      viewComponent={({ toggleModal }) => (
        <Flex vAlignContent="center" style={{ height: '100%' }}>
          <ActionComponent
            onClick={toggleModal}
            type="text"
            text={`See ${folder.permissions_user_count} users with access`}
          />
        </Flex>
      )}
      content={() => (
        <EntitySearch
          params={{
            permissions_folder_id: folder.guid,
          }}
          entityName={User.entityName}
          filters={[]}
          tableFormat
          hideFilters
        >
          {({ entities }): React.ReactElement => (
            <Flex column>
              {entities.map((user) => (
                <Flex
                  key={user.id}
                  vAlignContent="center"
                  style={{ gap: '5px', margin: '5px 0 ' }}
                >
                  <ProfilePicture entity={user} size={Size.mini} />
                  <label>{user.username}</label>
                </Flex>
              ))}
            </Flex>
          )}
        </EntitySearch>
      )}
    />
  ) : null;
